import React from 'react';
import classNames from 'classnames';

const ItemVisibilitySettings = (props) => {
  const visible = props.visible.value
  const isActive = (val) => val === visible;
  const device = (val) => val === 'mobile'

  const optionClasses = (val) => {
    return classNames(
      'btn btn-form',
      { 'active': isActive(val) }
    );
  };
  const iconSizeClasses = (val) => {
    return classNames(
      { 'fa-lg': device(val) }
    );
  }
  const handleChange = (val) => {
    const { onChange, visible: { field } } = props;
    onChange(field, val);
  };
  const { options = ['', 'desktop', 'mobile'] } = props;
  const renderOption = (value, index) => (
    <button
      className={optionClasses(value)}
      onClick={() => handleChange(value)}
      key={`position-y--${index}`}
    >
    { value ? <div className={`fa fa-${value} ${iconSizeClasses(value)}`}></div> : i18n.t('devices_all') }
    </button>
  );
  return (
    <div className="ftc-visibility-settings">
      <div className="btn-group">
        {options.map(renderOption)}
      </div>
    </div>
  );
};

export default ItemVisibilitySettings;
